import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { HREF } from '../constants';

export const userErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse & { isValidProfile: boolean }) => {
      const isUserEndpoint = req.url.includes('/api/user');
      const isUnprocessable = err.status === HttpStatusCode.UnprocessableEntity;
      const isForbidden = err.status === HttpStatusCode.Forbidden;

      const navigationExtras = { state: { errors: err.error?.Errors as string[] | undefined } };

      // Handle the specific case: 403 status from /api/user and isValidProfile false

      if (isUserEndpoint && isForbidden && !err.isValidProfile) {
        void router.navigate([HREF.MISSING_INFORMATION], navigationExtras);
        return throwError(() => new Error('User data profile is missing some information'));
      }

      // Handle the specific case: 422 or 403 status from /api/user
      if (isUserEndpoint && (isUnprocessable || isForbidden)) {
        void router.navigate([HREF.NOT_AVAILABLE], navigationExtras);
        return throwError(() => new Error('User data is not available'));
      }

      return throwError(() => err);
    }),
  );
};
